export default __webpack_public_path__ + "static/media/mec-thumbnail.6a218905.png";